import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum TerminationCategoryEnumDto {
    medical_leave = "medical_leave",
    contract_termination = "contract_termination",
}

export class TerminationCategoryDto {
    @IsEnum(TerminationCategoryEnumDto)
    @IsNotEmpty()
    key!: TerminationCategoryEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}
